import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useAPIInterceptor } from './utils/apiInterceptor';  
import PageLayout from './components/layout/PageLayout';
import LoginButton from './components/LoginButton';
import './styles/unified.css';

// Error handling components - NEW
import ErrorBoundary from './components/ErrorBoundary';
import Support from './components/pages/Support';
import Explore from './components/pages/Explore';

// Page imports
import Dashboard from './components/pages/Dashboard';
import SlotTemplate from './components/pages/Templates';
import Bookings from './components/pages/Bookings';
import ManageBookings from './components/pages/ManageBookings';
import Students from './components/pages/Students';
import Instructors from './components/pages/Instructors';
import Payments from './components/pages/Payments';
import Report from './components/pages/Report';
import Notifications from './components/pages/Notifications';
import Others from './components/pages/Others';
import StudentSignupPage from './components/pages/StudentSignupPage';
import InstructorSignupPage from './components/pages/InstructorSignupPage';
import Homepage from './components/pages/Homepage';
import HomepageMinimal from './components/pages/Homepage-Minimal';
import ManageTracker from './components/pages/ManageTracker';

function App() {
  const { isLoading, isAuthenticated, error } = useAuth0();

  useAPIInterceptor(); 

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading authentication...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <h2>Authentication Error</h2>
        <p>{error.message}</p>
        <button onClick={() => window.location.reload()}>Retry</button>
      </div>
    );
  }

  // Public routes (no authentication required, no sidebar)
  if (!isAuthenticated) {
    return (
      <Router>
        {/* Wrap with ErrorBoundary to catch errors in public routes */}
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/minimal" element={<HomepageMinimal />} />
            {/* Support/Error page - NEW - Must be accessible without auth */}
            <Route path="/support" element={<Support />} />
            <Route path="/explore" element={<Explore />} />
            
            {/* Public signup route - accessible without login */}
            <Route path="/signup" element={<StudentSignupPage />} />
            
            {/* Public instructor signup route - accessible without login */}
            <Route path="/instructorsignup" element={<InstructorSignupPage />} />
            
            {/* Default login page for all other routes */}
            <Route path="*" element={
              <div className="login-container">
                <div className="login-card">
                  <h1>Driving Instructor Booking System</h1>
                  <p>Please log in to continue</p>
                  <LoginButton />
                </div>
              </div>
            } />
          </Routes>
        </ErrorBoundary>
      </Router>
    );
  }

  // Protected routes (authentication required, with sidebar)
  return (
    <Router>
      {/* Wrap with ErrorBoundary to catch errors in protected routes */}
      <ErrorBoundary>
        <PageLayout>
          <Routes>
            {/* Support/Error page - NEW - Also accessible when authenticated */}
            <Route path="/support" element={<Support />} />
            
            {/* Existing protected routes */}
            <Route path="/" element={<Homepage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/template" element={<SlotTemplate />} />
            <Route path="/bookings" element={<Bookings />} />
            <Route path="/manage-students" element={<Students />} />
            <Route path="/instructors" element={<Instructors />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/report" element={<Report />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/manage-bookings" element={<ManageBookings />} />
            <Route path="/others" element={<Others />} />
            <Route path="/manage-tracker" element={<ManageTracker />} />
            
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
            <Route path="/signup" element={<StudentSignupPage />} />
          </Routes>
        </PageLayout>
      </ErrorBoundary>
    </Router>
  );
}

export default App;